import { useState } from 'react'
import { useBrand } from '../../context/BrandContext'

const purposes = ['Meeting','Interview','Delivery','Maintenance','Audit / Inspection','Training','Tour','Vendor Visit','Other']
const hosts = ['Tiffany Gallagher','John Gallagher','Kim Park','Dana Lee','Sam Rivera','Jamie Mitchell','Jordan Collins','Paula Reyes']

export default function VisitorKiosk() {
  const { brand } = useBrand()
  const accent = brand.primaryColor || '#B8734A'
  const [step, setStep] = useState(1)
  const [form, setForm] = useState({ firstName:'', lastName:'', company:'', host:'', purpose:'Meeting', phone:'', email:'', vehiclePlate:'' })
  const [agreed, setAgreed] = useState(false)
  const [sigName, setSigName] = useState('')
  const [badge, setBadge] = useState(null)

  function handleSignIn() {
    if (!form.firstName || !form.lastName || !form.host) { alert('Please fill in your name and who you are visiting.'); return }
    if (!agreed || !sigName.trim()) { alert('Please read and sign the visitor agreement.'); return }
    const num = 'V-' + String(Math.floor(Math.random() * 900) + 100)
    setBadge(num)
    setStep(4)
  }

  const inputStyle = { width:'100%', padding:'12px 16px', border:'1px solid #EDE6DA', borderRadius:8, fontSize:14, fontFamily:"'Montserrat',sans-serif", outline:'none', boxSizing:'border-box', color:'#2B2B2B' }
  const labelStyle = { display:'block', fontSize:10, textTransform:'uppercase', letterSpacing:'0.12em', color:'#6B7D6B', fontWeight:600, marginBottom:6 }

  return (
    <div style={{minHeight:'100vh',background:'#F7F2EB',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',fontFamily:"'Montserrat',sans-serif",padding:'2rem'}}>

      {/* Header */}
      <div style={{textAlign:'center',marginBottom:'2.5rem'}}>
        <div style={{width:56,height:56,borderRadius:'50%',border:`2px solid ${accent}`,display:'flex',alignItems:'center',justifyContent:'center',fontFamily:'Georgia,serif',fontSize:18,fontWeight:700,color:accent,margin:'0 auto 12px'}}>
          {brand.monogram || 'CS'}
        </div>
        <div style={{fontFamily:'Georgia,serif',fontSize:'1.6rem',fontWeight:600,color:'#2B2B2B',marginBottom:4}}>{brand.companyName || 'Demo Company'}</div>
        <div style={{fontSize:12,color:'#6B7D6B'}}>Visitor Sign-In</div>
      </div>

      <div style={{background:'#fff',borderRadius:16,width:'100%',maxWidth:560,boxShadow:'0 8px 40px rgba(43,43,43,0.1)',overflow:'hidden'}}>

        {/* Step indicator */}
        {step < 4 && (
          <div style={{padding:'16px 24px',borderBottom:'1px solid #EDE6DA',display:'flex',alignItems:'center',gap:8,background:'#2B2B2B'}}>
            {[['1','Your Info'],['2','Visit Details'],['3','Agreement']].map(([num,label],i)=>(
              <div key={num} style={{display:'flex',alignItems:'center',gap:6}}>
                <div style={{width:24,height:24,borderRadius:'50%',background:parseInt(num)<=step?accent:'rgba(255,255,255,0.1)',color:parseInt(num)<=step?'#fff':'rgba(255,255,255,0.3)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:11,fontWeight:700,flexShrink:0}}>
                  {parseInt(num)<step?'✓':num}
                </div>
                <span style={{fontSize:11,color:parseInt(num)<=step?'rgba(255,255,255,0.9)':'rgba(255,255,255,0.3)',fontWeight:parseInt(num)===step?600:400}}>{label}</span>
                {i<2 && <div style={{width:24,height:1,background:'rgba(255,255,255,0.15)',marginLeft:4}}></div>}
              </div>
            ))}
          </div>
        )}

        <div style={{padding:'2rem'}}>

          {/* STEP 1 — Personal Info */}
          {step === 1 && (
            <div style={{display:'flex',flexDirection:'column',gap:16}}>
              <div style={{fontFamily:'Georgia,serif',fontSize:'1.2rem',color:'#2B2B2B',fontWeight:600,marginBottom:4}}>Welcome! Let us know who you are.</div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14}}>
                <div>
                  <label style={labelStyle}>First Name *</label>
                  <input value={form.firstName} onChange={e=>setForm(f=>({...f,firstName:e.target.value}))} placeholder="First name" style={inputStyle}/>
                </div>
                <div>
                  <label style={labelStyle}>Last Name *</label>
                  <input value={form.lastName} onChange={e=>setForm(f=>({...f,lastName:e.target.value}))} placeholder="Last name" style={inputStyle}/>
                </div>
                <div style={{gridColumn:'1/-1'}}>
                  <label style={labelStyle}>Company / Organization</label>
                  <input value={form.company} onChange={e=>setForm(f=>({...f,company:e.target.value}))} placeholder="Optional" style={inputStyle}/>
                </div>
                <div>
                  <label style={labelStyle}>Phone (optional)</label>
                  <input value={form.phone} onChange={e=>setForm(f=>({...f,phone:e.target.value}))} placeholder="(207) 555-0000" style={inputStyle}/>
                </div>
                <div>
                  <label style={labelStyle}>Email (optional)</label>
                  <input value={form.email} onChange={e=>setForm(f=>({...f,email:e.target.value}))} placeholder="your@email.com" style={inputStyle}/>
                </div>
              </div>
              <button onClick={()=>{if(!form.firstName||!form.lastName){alert('Please enter your name.');return}setStep(2)}}
                style={{padding:'14px',background:accent,border:'none',borderRadius:8,color:'#fff',fontSize:14,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",marginTop:8}}>
                Continue →
              </button>
            </div>
          )}

          {/* STEP 2 — Visit Details */}
          {step === 2 && (
            <div style={{display:'flex',flexDirection:'column',gap:16}}>
              <div style={{fontFamily:'Georgia,serif',fontSize:'1.2rem',color:'#2B2B2B',fontWeight:600,marginBottom:4}}>Tell us about your visit.</div>
              <div>
                <label style={labelStyle}>Who are you here to see? *</label>
                <select value={form.host} onChange={e=>setForm(f=>({...f,host:e.target.value}))} style={inputStyle}>
                  <option value="">Select a host...</option>
                  {hosts.map(h=><option key={h}>{h}</option>)}
                </select>
              </div>
              <div>
                <label style={labelStyle}>Purpose of Visit</label>
                <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:8}}>
                  {purposes.map(p=>(
                    <button key={p} onClick={()=>setForm(f=>({...f,purpose:p}))}
                      style={{padding:'10px 8px',border:`2px solid ${form.purpose===p?accent:'#EDE6DA'}`,borderRadius:8,background:form.purpose===p?accent+'11':'#fff',color:form.purpose===p?accent:'#4A4A4A',fontSize:12,fontWeight:form.purpose===p?600:400,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                      {p}
                    </button>
                  ))}
                </div>
              </div>
              <div>
                <label style={labelStyle}>Vehicle License Plate (optional)</label>
                <input value={form.vehiclePlate} onChange={e=>setForm(f=>({...f,vehiclePlate:e.target.value}))} placeholder="e.g. ME 123ABC" style={inputStyle}/>
              </div>
              <div style={{display:'flex',gap:10}}>
                <button onClick={()=>setStep(1)} style={{flex:1,padding:'14px',background:'#fff',border:'1px solid #EDE6DA',borderRadius:8,color:'#4A4A4A',fontSize:14,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>← Back</button>
                <button onClick={()=>{if(!form.host){alert('Please select who you are visiting.');return}setStep(3)}}
                  style={{flex:2,padding:'14px',background:accent,border:'none',borderRadius:8,color:'#fff',fontSize:14,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                  Continue →
                </button>
              </div>
            </div>
          )}

          {/* STEP 3 — NDA / Agreement */}
          {step === 3 && (
            <div style={{display:'flex',flexDirection:'column',gap:16}}>
              <div style={{fontFamily:'Georgia,serif',fontSize:'1.2rem',color:'#2B2B2B',fontWeight:600,marginBottom:4}}>Visitor Agreement</div>
              <div style={{background:'#F7F2EB',borderRadius:8,padding:'16px',maxHeight:220,overflowY:'auto',border:'1px solid #EDE6DA'}}>
                <div style={{fontSize:12,color:'#4A4A4A',lineHeight:1.9}}>
                  <strong>Visitor Agreement & Non-Disclosure</strong><br/><br/>
                  By signing below, I agree to the following terms during my visit to {brand.companyName || 'this facility'}:<br/><br/>
                  <strong>1. Confidentiality.</strong> I agree to keep confidential any proprietary information, business operations, personnel matters, client information, or trade secrets I may observe or overhear during my visit.<br/><br/>
                  <strong>2. Conduct.</strong> I agree to conduct myself professionally and comply with all facility rules, safety procedures, and directions from staff at all times.<br/><br/>
                  <strong>3. Escort Policy.</strong> I understand I must remain with my host or designated escort at all times unless authorized otherwise.<br/><br/>
                  <strong>4. Photography & Recording.</strong> I agree not to photograph, record, or capture any images of the facility, staff, or operations without express written permission.<br/><br/>
                  <strong>5. Personal Property.</strong> I acknowledge that the organization is not responsible for loss or damage to personal property during my visit.<br/><br/>
                  <strong>6. Safety.</strong> In the event of an emergency, I agree to follow staff instructions and evacuation procedures immediately.
                </div>
              </div>
              <label style={{display:'flex',alignItems:'flex-start',gap:12,cursor:'pointer',padding:'12px',background:agreed?'rgba(74,124,89,0.06)':'#fff',border:`1px solid ${agreed?'#4A7C59':'#EDE6DA'}`,borderRadius:8,transition:'all 0.15s'}}>
                <input type="checkbox" checked={agreed} onChange={e=>setAgreed(e.target.checked)} style={{accentColor:accent,width:18,height:18,marginTop:1,flexShrink:0}}/>
                <span style={{fontSize:13,color:'#2B2B2B',lineHeight:1.5}}>I have read and agree to the Visitor Agreement and Non-Disclosure terms above.</span>
              </label>
              <div style={{border:'2px dashed #D9C3A3',borderRadius:8,padding:'16px',textAlign:'center'}}>
                <div style={{fontSize:10,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,marginBottom:8}}>Sign your full name to confirm</div>
                <input value={sigName} onChange={e=>setSigName(e.target.value)} placeholder="Type your full legal name"
                  style={{width:'100%',padding:'12px 16px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:16,fontFamily:'Georgia,serif',outline:'none',textAlign:'center',color:'#2B2B2B',boxSizing:'border-box'}}/>
              </div>
              <div style={{display:'flex',gap:10}}>
                <button onClick={()=>setStep(2)} style={{flex:1,padding:'14px',background:'#fff',border:'1px solid #EDE6DA',borderRadius:8,color:'#4A4A4A',fontSize:14,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>← Back</button>
                <button onClick={handleSignIn}
                  style={{flex:2,padding:'14px',background:'#4A7C59',border:'none',borderRadius:8,color:'#fff',fontSize:14,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                  Complete Sign-In ✓
                </button>
              </div>
            </div>
          )}

          {/* STEP 4 — Badge */}
          {step === 4 && (
            <div style={{textAlign:'center',padding:'1rem 0'}}>
              <div style={{width:80,height:80,borderRadius:'50%',background:'rgba(74,124,89,0.1)',border:'3px solid #4A7C59',display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 16px',fontSize:36}}>✓</div>
              <div style={{fontFamily:'Georgia,serif',fontSize:'1.5rem',color:'#2B2B2B',fontWeight:600,marginBottom:8}}>Welcome, {form.firstName}!</div>
              <div style={{fontSize:13,color:'#6B7D6B',marginBottom:'1.5rem'}}>You have been signed in. Your host has been notified.</div>

              {/* Badge */}
              <div style={{background:'#2B2B2B',borderRadius:12,padding:'1.5rem',marginBottom:'1.5rem',border:`3px solid ${accent}`}}>
                <div style={{fontSize:10,color:'rgba(217,195,163,0.5)',textTransform:'uppercase',letterSpacing:'0.15em',marginBottom:6}}>Visitor Badge</div>
                <div style={{fontFamily:'Georgia,serif',fontSize:'2.5rem',fontWeight:700,color:accent,marginBottom:4}}>{badge}</div>
                <div style={{fontFamily:'Georgia,serif',fontSize:'1.1rem',color:'#fff',marginBottom:2}}>{form.firstName} {form.lastName}</div>
                {form.company && <div style={{fontSize:12,color:'rgba(217,195,163,0.5)',marginBottom:6}}>{form.company}</div>}
                <div style={{display:'flex',justifyContent:'center',gap:'1.5rem',marginTop:12,paddingTop:12,borderTop:'1px solid rgba(255,255,255,0.1)'}}>
                  <div style={{textAlign:'center'}}>
                    <div style={{fontSize:9,color:'rgba(217,195,163,0.4)',textTransform:'uppercase',letterSpacing:'0.1em'}}>Visiting</div>
                    <div style={{fontSize:12,color:'rgba(217,195,163,0.8)',fontWeight:500}}>{form.host}</div>
                  </div>
                  <div style={{textAlign:'center'}}>
                    <div style={{fontSize:9,color:'rgba(217,195,163,0.4)',textTransform:'uppercase',letterSpacing:'0.1em'}}>Purpose</div>
                    <div style={{fontSize:12,color:'rgba(217,195,163,0.8)',fontWeight:500}}>{form.purpose}</div>
                  </div>
                </div>
              </div>

              <div style={{padding:'12px 16px',background:'rgba(74,124,89,0.06)',border:'1px solid rgba(74,124,89,0.2)',borderRadius:8,fontSize:12,color:'#4A7C59',marginBottom:'1.5rem',textAlign:'left',lineHeight:1.7}}>
                ✓ Please wear or carry your badge number visible at all times.<br/>
                ✓ Remain with your host or escort.<br/>
                ✓ Sign out at this kiosk when you leave.
              </div>

              <button onClick={()=>{setStep(1);setForm({firstName:'',lastName:'',company:'',host:'',purpose:'Meeting',phone:'',email:'',vehiclePlate:''});setAgreed(false);setSigName('');setBadge(null)}}
                style={{padding:'12px 32px',background:accent,border:'none',borderRadius:8,color:'#fff',fontSize:13,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                Sign In Another Visitor
              </button>
              <button onClick={()=>window.print()}
                style={{padding:'12px 32px',background:'#2B2B2B',border:'none',borderRadius:8,color:'#fff',fontSize:13,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",marginTop:8}}>
                Print Visitor Badge
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
